import { render } from "./NotificationBell.vue?vue&type=template&id=67cdecfa&scoped=true"
import script from "./NotificationBell.js?vue&type=script&lang=js&external"
export * from "./NotificationBell.js?vue&type=script&lang=js&external"

import "./NotificationBell.css?vue&type=style&index=0&id=67cdecfa&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67cdecfa"]])

export default __exports__